import axios from "axios";

// Read env vars (Vite exposes them under import.meta.env)
// const env = import.meta.env.VITE_ENV;
const baseURL = import.meta.env.VITE_DND_APP_BACKEND_URL;

const useAxios = axios.create({
});

useAxios.interceptors.request.use(
  async (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    return config;
  },
  (error) => Promise.reject(error)
);

useAxios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default useAxios;



